/* French-Youngtimer-Parts – Pflicht-Variantenauswahl ohne Vorauswahl.
   Deaktiviert die automatische Variantenvorauswahl auf Produktseiten:
   Kunden müssen alle Optionen aktiv wählen, erst dann wird „In den Warenkorb“ aktiv.
   Der Button bleibt dabei voll eingefärbt (kein Ausverkauft-Look) und führt bei Klick
   zur Variantenauswahl. Links mit ?variant=… wählen weiterhin gezielt vor (gewollt). */
(function () {
  'use strict';

  if (/[?&]variant=/.test(window.location.search)) return;

  var LANGS = {
    de: { choose: 'Bitte Variante wählen', hint: 'Bitte wähle zuerst:', placeholder: 'Bitte wählen' },
    en: { choose: 'Please select a variant', hint: 'Please select first:', placeholder: 'Please select' },
    fr: { choose: 'Veuillez choisir une variante', hint: 'Veuillez d’abord choisir :', placeholder: 'Veuillez choisir' },
    es: { choose: 'Selecciona una variante', hint: 'Primero selecciona:', placeholder: 'Seleccionar' }
  };
  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var T = LANGS[lang] || LANGS.en;

  var CSS = '.np-gated{cursor:pointer}' +
    '.np-incomplete .shopify-payment-button{display:none}' +
    '.np-hint{display:none;color:#c0392b;font-size:1.3rem;line-height:1.4;margin-top:1rem}' +
    '.np-hint.show{display:block}' +
    '.np-flash{outline:.2rem solid #c0392b;outline-offset:.4rem;border-radius:.4rem}';

  function init() {
    var picker = document.querySelector('section[id^="MainProduct-"] variant-selects') ||
      document.querySelector('variant-selects');
    if (!picker) return;

    var sectionId = picker.dataset.section;
    var submit = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!submit) return;
    if (submit.disabled) return; /* z. B. komplett ausverkauft – Theme-Verhalten nicht anfassen */
    var productForm = submit.closest('product-form');
    var form = submit.closest('form');
    var submitSpan = submit.querySelector('span') || submit;

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var groups = [];
    picker.querySelectorAll('fieldset').forEach(function (fs) {
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;
      var legend = fs.querySelector('legend');
      radios.forEach(function (r) { r.checked = false; });
      groups.push({ el: fs, name: legend ? legend.textContent.trim().replace(/:\s*$/, '') : '', chosen: false });
    });
    picker.querySelectorAll('select').forEach(function (sel) {
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = T.placeholder;
      ph.disabled = true;
      ph.selected = true;
      sel.insertBefore(ph, sel.firstChild);
      var wrap = sel.closest('.product-form__input') || sel.parentElement;
      var label = wrap ? wrap.querySelector('label, .form__label') : null;
      groups.push({ el: wrap || sel, name: label ? label.textContent.trim() : '', chosen: false, placeholder: ph });
    });
    if (!groups.length) return;

    var hint = document.createElement('div');
    hint.className = 'np-hint';
    hint.setAttribute('role', 'alert');
    picker.appendChild(hint);

    var originalLabel = submitSpan.textContent;
    submitSpan.textContent = T.choose;
    submit.classList.add('np-gated');
    if (productForm) productForm.classList.add('np-incomplete');

    var complete = false;

    function missing() {
      return groups.filter(function (g) { return !g.chosen; }).map(function (g) { return g.name; }).filter(Boolean);
    }

    function updateHint() {
      var miss = missing();
      hint.textContent = miss.length ? T.hint + ' ' + miss.join(', ') : '';
      if (!miss.length) hint.classList.remove('show');
    }

    function finish() {
      complete = true;
      submit.classList.remove('np-gated');
      submitSpan.textContent = originalLabel;
      if (productForm) productForm.classList.remove('np-incomplete');
      hint.classList.remove('show');
      groups.forEach(function (g) {
        if (g.placeholder && g.placeholder.parentNode) g.placeholder.parentNode.removeChild(g.placeholder);
      });
    }

    document.addEventListener('change', function (e) {
      if (complete) return;
      if (!picker.contains(e.target)) return;
      var g = null;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].el.contains(e.target)) { g = groups[i]; break; }
      }
      if (g) g.chosen = true;
      var allChosen = groups.every(function (x) { return x.chosen; });
      if (allChosen) {
        finish(); /* Event läuft normal weiter ans Theme: Preis, Bild, Verfügbarkeit aktualisieren */
      } else {
        e.stopImmediatePropagation(); /* Auswahl unvollständig – Theme noch nicht informieren */
        updateHint();
      }
    }, true);

    function nudge() {
      updateHint();
      hint.classList.add('show');
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      groups.forEach(function (g) {
        if (g.chosen) return;
        g.el.classList.add('np-flash');
        setTimeout(function () { g.el.classList.remove('np-flash'); }, 1600);
      });
    }

    document.addEventListener('click', function (e) {
      if (complete) return;
      if (!e.target.closest) return;
      if (e.target.closest('#ProductSubmitButton-' + sectionId) || e.target.closest('.shopify-payment-button')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge();
      }
    }, true);

    if (form) {
      form.addEventListener('submit', function (e) {
        if (complete) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge();
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
